import styled from "styled-components";

export const ToggleContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    gap: 6px;
    font-size: ${props => props.theme.fontSize.subtitle2};
    font-weight: ${props => props.theme.fontWeight.medium};
    
    justify-content: flex-end;
    ${props => props.theme.screenMediaQuery.smallScreen} {
        justify-content: space-between;
    }
`

export const LabelBox = styled.div`
    flex-grow: 1;
`

export const IconBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    justify-content: center;
    width: 24px;
    height: 24px;
`

export const LabelAndIconContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    max-width: min(100%, 330px);
    ${props => props.theme.screenMediaQuery.smallScreen} {
        max-width: unset;
    }
`